import { render, staticRenderFns } from "./AreasFormHint.vue?vue&type=template&id=bf13870a&scoped=true"
import script from "./AreasFormHint.vue?vue&type=script&lang=js"
export * from "./AreasFormHint.vue?vue&type=script&lang=js"
import style0 from "./AreasFormHint.vue?vue&type=style&index=0&id=bf13870a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf13870a",
  null
  
)

export default component.exports